export const CART_COUNT = "CART_COUNT";
export const SET_CART_COUNT = "SET_CART_COUNT";
export const SET_CART_DATA = "SET_CART_DATA";